import {Branding} from "@irati/types"

const defaultBranding: Branding = {
  uuid: "uuid",
  businessId: "busiensId",
  teamId: "teamId",
  businessLogoUrl:
    "https://res.cloudinary.com/perkbox/image/upload/v1616081665/deals-light-ui/shared/Logo_-_Perkbox_Logo_Perkbox_Blue_-_2019.png",
  businessSquareLogoUrl: "",
  isEnabled: true,
  primaryColour: "#00adef",
  textColour: "#000"
}

export default defaultBranding
